import Roles from "../../../views/Roles";
import RolesBulkUpload from "../../../views/Roles/RolesBulkUpload";
import AttributeMapping from "../../../views/Roles/AttributeMapping";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const localityRoutes = [
  {
    path: "/role-management",
    component: Roles,
    exact: true,
    menuName: MenuNames.ROLE_MANAGEMENT,
  },
  {
    path: "/roles-bulk-upload",
    component: RolesBulkUpload,
    exact: true,
    menuName: MenuNames.BULK_UPLOAD_AUTH_DETAILS,
  },
  {
    path: "/attribute-mapping",
    component: AttributeMapping,
    exact: true,
    menuName: MenuNames.ATTRIBUTE_MAPPING,
  },
];

export default localityRoutes;
